import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, TextField, Typography, useTheme } from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { ButtonBasic } from '../../components';
import { toast } from 'react-toastify';
import ApiSoftland from '../../services/apis.softland.service';

const ModalDeleteClienteEventual = ({ show, hideModal, onGuardar }) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isLoading, setIsLoading] = useState(false);
    const [numeroServicio, setNumeroServicio] = useState('');
    const [error, setError] = useState(false);

    const handleClose = () => hideModal();

    const handleConfirm = async () => {
        if (!numeroServicio?.trim()) {
            setError(true);
            return;
        }
        setIsLoading(true);
        try {
            await ApiSoftland.deleteClienteEventual(numeroServicio.trim());
            toast.success('El cliente eventual fue eliminado correctamente.');
            if (onGuardar) onGuardar();
            handleClose();
        } catch (err) {
            const msg = err?.response?.data?.msg || 'Ocurrió un error al eliminar el cliente eventual.';
            toast.error(msg);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='xs' fullWidth sx={{ backdropFilter: 'blur(0.4px)' }}>
            <Box sx={{ background: isDarkMode ? '#1F2A40' : '#fff' }}>
                <DialogTitleDefault id="delete-eventual" onClose={handleClose}>
                    <Typography sx={{ flex: 1, textAlign: 'center', color: isDarkMode ? '#fff' : '#000', fontWeight: 'bold' }} variant='h5'>
                        Eliminar Servicio Eventual
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{ background: isDarkMode ? '#3d4a62' : 'gray' }} />
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 1 }}>
                        <DeleteForeverIcon sx={{ fontSize: 48, color: '#f44336' }} />
                        <Typography sx={{ color: isDarkMode ? '#ccc' : '#555', textAlign: 'center', fontSize: 13 }}>
                            Ingresá el número de servicio eventual a eliminar. Si el cliente no tiene otros contratos asociados, también se eliminará la cuenta.
                        </Typography>
                        <TextField
                            label='Número de servicio'
                            value={numeroServicio}
                            onChange={(e) => {
                                setNumeroServicio(e.target.value);
                                setError(false);
                            }}
                            error={error}
                            helperText={error ? 'El número de servicio es obligatorio.' : ''}
                            fullWidth
                            size='small'
                            inputProps={{ maxLength: 20 }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    color: isDarkMode ? '#fff' : '#000',
                                }
                            }}
                        />
                    </Box>
                </DialogContent>
                <Divider sx={{ background: isDarkMode ? '#3d4a62' : 'gray' }} />
                <DialogActions sx={{ justifyContent: 'center', gap: 1, p: 2 }}>
                    <ButtonBasic
                        textButton='CANCELAR'
                        variant='wk'
                        color='nextStep'
                        onClick={handleClose}
                        isDisabled={isLoading}
                        sx={{ borderRadius: 2 }}
                    />
                    <ButtonBasic
                        textButton='ELIMINAR'
                        variant='contained'
                        color='error'
                        onClick={handleConfirm}
                        isLoading={isLoading}
                        sx={{ borderRadius: 2 }}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default ModalDeleteClienteEventual;
